<template>
	<b-container class="pt-4">
		<b-modal id="signup" v-model="show_signup" v-if="show_signup || signup_loaded" size="xl" :hide-footer="true" title="Tilmelding" no-close-on-esc>
			<sb-signup ref="signup_form" @submitted="show_signup = false" :_account_type="version" :_employees="(users.module_active && version != 'lite') ? users.active : 0" :_finance="modules.finance.active || !modules.finance.optional" :_pbs="modules.pbs.active" :_price_calculator="modules.offer.active" :_api="modules.api.active" :_period="period" />
		</b-modal>


		<h1>Priser</h1>
		<p>
			Her kan du se priserne for SkvizBiz. Du kan bruge tabellen herunder til at finde ud af præcis hvad SkvizBiz kommer til at koste dig.<br>
			Og længere nede på siden kan du læse mere om de enkelte moduler.
		</p>
		<div>
			<table class="table table-sm">
				<thead>
					<tr>
						<th style="width:10px;">&nbsp;</th>
						<th>&nbsp;</th>
						<th class="text-right">Oprettelse</th>
						<th class="text-right">Pris pr. måned</th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td><b-form-radio-group plain v-model="version"><b-form-radio style="margin-right: -10px;" name="version" value="lite" id="version_lite" /></b-form-radio-group></td>
						<td>
							<label for="version_lite" style="margin-bottom: 0;">Lite</label> <b-badge variant="info" href="javascript:void(0);" id="lite_version_info"><fa :icon="farInfoCircle"></fa></b-badge>
							<b-popover target="lite_version_info" triggers="hover focus" boundary="viewport">
								<b-card deck no-body variant="info" header="SkvizBiz – Lite" header-tag="h4" style="margin:-9px -13px; width:350px;">
									<b-list-group flush>
										<b-list-group-item class="d-flex w-100 justify-content-between"><strong>Opstart</strong><span>kr. <animated-number :value="base_lite.installation" :formatValue="price_format" /></span></b-list-group-item>
										<b-list-group-item class="d-flex w-100 justify-content-between"><strong>Pris pr. måned</strong><span>kr. <animated-number :value="base_lite.subscription[1] + modules.finance.subscription" :formatValue="price_format" /></span></b-list-group-item>
									</b-list-group>
									<b-card-body>
										Forskelle mellem lite-udgaven og den fulde version:
										<ul>
											<li>Dit kundekartotek er begrænset til 50 kunder.<br>Hvis du indtaster flere kunder, hæves prisen gradvist med kr. {{ price_format(base_lite.additional_customer_price) }} pr. kunde, dog højst med kr. {{ price_format(base_lite.additional_customer_price * base_lite.max_additional_customers) }}<br>
											Herefter vil du sikkert være klar til at opgradere til fuld version, og kan gøre det uden at dit abonnement stiger.</li>
											<li>Fakturaopsætning er ikke inkluderet i opstarten. Hvis du ønsker et andet udseende end vores standardskabelon skal det tilkøbes (se under "Ekstra fakturaskabelon").</li>
											<li>Indlæsning af kundedata er ikke inkluderet. Hvis du ønsker at få indlæst kunder fra en datafil, så skal det tilkøbes (se under "Dataudlæsning" og "Programmørhjælp".</li>
										</ul>
									</b-card-body>
								</b-card>
							</b-popover>
							<p class="mb-0">Forventet antal kunder: <b-form-input type="number" size="sm" :min="1" :max="300" v-model="base_lite.estimated_customers" inline style="margin-top: -.5em; margin-bottom: -.5em; width: 60px; display: inline-block;" /><b-form-input @click.stop type="range" min="1" :max="Math.max(base_lite.estimated_customers, 300)" v-model="base_lite.estimated_customers" inline /></p>
						</td>
						<td class="text-right" :class="[version == 'lite' ? 'table-success' : '']">{{ price_format(base_lite.installation) }}</td>
						<td class="text-right" :class="[version == 'lite' ? 'table-success' : '']">{{ price_format(this.variable_prices.lite.subscription) }}</td>
					</tr>
					<tr>
						<td><b-form-radio-group plain v-model="version"><b-form-radio style="margin-right: -10px;" name="version" value="standard" id="version_standard" /></b-form-radio-group></td>
						<td>
							<label for="version_standard" style="margin-bottom: 0;">Fuld version</label> <b-badge variant="info" href="javascript:void(0);" id="full_version_info"><fa :icon="farInfoCircle"></fa></b-badge><!-- <select v-model="users.active"><option v-for="(subscription, users) in base_full.subscription" :key="users" :value="users">{{ users == 1 ? "uden medarbejdermodul" : "med op til "+users+" medarbejdere/logins" }}</option></select> -->
							<b-popover target="full_version_info" triggers="hover focus" boundary="viewport">
								<b-card deck no-body variant="primary" header="SkvizBiz – Fuld version" header-tag="h4" style="margin:-9px -13px; width:350px;">
									<b-list-group flush>
										<b-list-group-item class="d-flex w-100 justify-content-between"><strong>Opstart</strong><span>kr. <animated-number :value="base_full.installation" :formatValue="price_format" /></span></b-list-group-item>
										<b-list-group-item class="d-flex w-100 justify-content-between"><strong>Pris pr. måned</strong><span>kr. <animated-number :value="base_full.subscription[1]" :formatValue="price_format" /></span></b-list-group-item>
									</b-list-group>
									<b-card-body>
										Udover selve programmet får du:
										<ul class="!list-group">
											<li class="!list-group-item">Indlæsning af kundedata<sup>1</sup> til SkvizBiz</li>
											<li class="!list-group-item">Fri support på telefon og email<sup>2</sup></li>
											<li class="!list-group-item">Opsætning af egen faktura og/eller indbetalingskort</li>
											<li class="!list-group-item">Adgang til nye versioner, når de frigives</li>
											<li class="!list-group-item">Fri adgang til kursusvideoer</li>
											<li class="!list-group-item">1 times udvidet kursus i betjening af programmet</li>
											<li class="!list-group-item">Ubegrænset antal kunder, fakturaer og historik</li>
											<li class="!list-group-item">1GB dataplads til uploadede filer (bilag og kundefiler)</li>
											<li class="!list-group-item">Vi vedligeholder og opdaterer programmet</li>
											<li class="!list-group-item">Vi sørger for daglig backup af alle data</li>
										</ul>
									</b-card-body>
								</b-card>
							</b-popover>
						</td>
						<td class="text-right" :class="[version == 'standard' ? 'table-success' : '']">{{ price_format(base_full.installation) }}</td>
						<td class="text-right" :class="[version == 'standard' ? 'table-success' : '']">{{ price_format(this.base_full.subscription[1]) }}</td>
					</tr>
					<tr>
						<td><!-- <b-form-checkbox v-if="version == 'standard'" plain style="margin-right: -10px;" disabled v-model="users.module_active" /><b-form-checkbox v-if="version == 'lite'" plain disabled :checked="false" style="margin-right: -10px;" /> --></td>
						<!-- <td @click.self="users.module_active = !users.module_active" style="cursor: pointer;">Medarbejdermodul, <b-form-select style="width: 75px;" v-model="users.active"><option v-for="user_count in users.threshold" :key="user_count" :value="user_count">{{ user_count }}</option></b-form-select> ekstra medarbejdere/logins</td> -->
						<!-- <td @click.self="users.module_active = !users.module_active" style="cursor: pointer;">Medarbejdermodul, <b-form-spinbutton size="sm" min="1" :max="users.threshold" v-model="users.active" inline style="margin-top: -.5em; margin-bottom: -.5em;" /> ekstra medarbejdere/logins</td> -->
						<td style="cursor: pointer;"><!-- <span style="font-variant-numeric: tabular-nums;">{{users.active}}</span> --> Ekstra medarbejdere/logins: <b-form-input type="number" size="sm" :min="0" :max="200" v-model="users.active" inline style="margin-top: -.5em; margin-bottom: -.5em; width: 60px; display: inline-block;" /><b-form-input type="range" min="0" :max="Math.max(users.active, users.threshold)" v-model="users.active" /></td>
						<td class="text-right" :class="[users.module_active && version == 'standard' ? 'table-success' : '']"><animated-number :value="employee_module(1).installation" :formatValue="price_format" /></td>
						<td class="text-right" :class="[users.module_active && version == 'standard' ? 'table-success' : '']"><animated-number :value="employee_module(1).subscription" :formatValue="price_format" /></td>
					</tr>
					<tr v-for="(module, id) in modules" :key="module.name">
						<td><b-form-checkbox plain v-if="module.optional" style="margin-right: -10px;" v-model="modules_active" :value="id" /><b-form-checkbox plain v-else disabled :checked="true" style="margin-right: -10px;" /></td>
						<td :style="[module.optional ? {cursor: 'pointer'} : false]" @click="toggle_module(id)">{{ module.name }}
							<b-badge v-if="module.info" variant="info" @click.stop href="javascript:void(0);" :id="`${module.name}_info`"><fa :icon="farInfoCircle"></fa></b-badge>
							<b-popover v-if="module.info" :target="`${module.name}_info`" triggers="hover focus" boundary="viewport">
								<b-card deck no-body variant="info" style="margin:-9px -13px; width:350px;"><b-card-body v-html="module.info"></b-card-body></b-card>
							</b-popover>
							<p v-if="id == 'pbs'" class="mb-0">Forventet antal månedlige PBS-betalinger: <strong><b-form-input @click.stop type="number" size="sm" min="1" :max="200" v-model="pbs.estimated_monthly_payments" inline style="margin-top: -.5em; margin-bottom: -.5em; width: 80px; display: inline-block;" /><!-- {{ pbs.estimated_monthly_payments }} --></strong><b-form-input @click.stop type="range" min="0" :max="Math.max(pbs.estimated_monthly_payments, 1000)" v-model="pbs.estimated_monthly_payments" inline /></p>
						</td>
						<td class="text-right" :class="[(module.active || !module.optional) ? 'table-success' : '']"><animated-number :value="module.installation" :formatValue="price_format" /></td>
						<td class="text-right" :class="[(module.active || !module.optional) ? 'table-success' : '']"><animated-number :value="module.subscription" :formatValue="price_format" /></td>
					</tr>
				</tbody>
				<tfoot>
					<tr>
						<td></td>
						<td><strong>I alt</strong></td>
						<td class="text-right table-success"><strong><animated-number :value="total_installation()" :formatValue="price_format" /></strong></td>
						<td class="text-right table-success"><strong><animated-number :value="total_subscription(1).price" :formatValue="price_format" /></strong></td>
					</tr>
				</tfoot>
			</table>
			<br>
			<div >
				<!-- <h4>Ved valg af {{ (period == 12 ? 'årsfakturering' : '') + (period == 3 ? 'kvartalsfakturering' : '') + (period == 1 ? 'månedsfakturering' : '') }}:</h4> -->
				<h4>Vælg faktureringsperiode: <b-button-group size="md">
						<b-button :variant="price_period=='1' ? 'primary' : 'outline-primary'" :pressedTest="price_period=='1'" @click="period = '1'"><strong>månedsfakturering</strong></b-button>
						<b-button :variant="price_period=='3' ? 'primary' : 'outline-primary'" :pressedTest="price_period=='3'" @click="period = '3'"><strong>kvartalsfakturering</strong></b-button>
						<b-button :variant="price_period=='12' ? 'primary' : 'outline-primary'" :pressedTest="price_period=='12'" @click="period = '12'"><strong>årsfakturering</strong></b-button>
					</b-button-group>
				</h4>
				<p>
					Hvis du vælger {{ (period == 12 ? 'årsfakturering' : '') + (period == 3 ? 'kvartalsvis fakturering' : '') + (period == 1 ? 'månedsfakturering' : '') }} vil din første faktura lyde på <strong>kr. <animated-number :value="total_installation() + (total_subscription(period).price * (period==12 ? months_left_in_year : (period == 3 ? months_left_in_quarter : 1)))" :formatValue="price_format" /></strong> (oprettelse til kr. <animated-number :value="total_installation()" :formatValue="price_format" /> + <animated-number :value="period==12 ? months_left_in_year : (period == 3 ? months_left_in_quarter : 1)" :formatValue="Math.round" /> {{period != 1 ? 'måneder' : 'måned'}} á kr. <animated-number :value="total_subscription(period).price" :formatValue="price_format" />)<br>
					Herefter vil du en gang {{ (period == 12 ? 'om året' : '') + (period == 3 ? 'i kvartalet' : '') + (period == 1 ? 'om måneden' : '') }} få en faktura på <strong>kr. <animated-number :value="total_subscription(period).price * period" :formatValue="price_format" /></strong> (<animated-number :value="period" :formatValue="Math.round" /> {{period != 1 ? 'måneder' : 'måned'}} á kr. <animated-number :value="total_subscription(period).price" :formatValue="price_format" />)<br>
					<strong v-if="period == 1">Månedsfakturering kræver at du betaler via BetalingsService.</strong>
				</p>
			</div>
			<div class="d-flex justify-content-between align-items-center">
				<div><i>Alle priser er ekskl. moms.</i></div>
				<div><b-button variant="success" pull-right @click="show_signup = !show_signup; signup_loaded = true;">Bestil nu (med {{ period_string }})</b-button></div>
			</div>
		</div>

		<hr>

		<div class="d-flex justify-content-between align-items-center">
		</div>

		<b-row>
			<b-col md="6">
				<h1>Prisliste</h1>
				<p>Når du køber SkvizBiz, skal du betale en af opstartspakkerne (Fuld version eller Lite), som er beskrevet her på siden. Du kan også tilvælge et eller flere af de valgfri moduler, som er beskrevet længere nede på siden.</p>
				<p>Foruden opstartspakken koster det et månedligt abonnement at bruge SkvizBiz. Prisen afgøres af antallet af medarbejdere, som du styrer i programmet.</p>
			</b-col>
			<b-col md="6">
				<b-card deck no-body variant="info" header="Forskelle mellem lite-udgaven og fuld version" header-tag="h4">
					<b-list-group flush>
						<b-list-group-item>Dit kundekartotek er begrænset til 50 kunder.<br>Hvis du indtaster flere kunder, hæves prisen gradvist med kr. {{ price_format(base_lite.additional_customer_price) }} pr. kunde, dog højst med kr. {{ price_format(base_lite.additional_customer_price * base_lite.max_additional_customers) }}<br>
						Herefter vil du sikkert være klar til at opgradere til fuld version, og kan gøre det uden at dit abonnement stiger.</b-list-group-item>
						<b-list-group-item>Fakturaopsætning er ikke inkluderet i opstarten. Hvis du ønsker et andet udseende end vores standardskabelon skal det tilkøbes (se prislisten herover).</b-list-group-item>
						<b-list-group-item>Indlæsning af kundedata er ikke inkluderet. Hvis du ønsker at få indlæst kunder fra en datafil, så skal det tilkøbes (se under "Dataudlæsning" og "Programmørhjælp".</b-list-group-item>
					</b-list-group>
				</b-card>
			</b-col>
		</b-row>


		<h2 class="mt-4 mb-2">Indbyggede moduler</h2>
		<div class="row">
			<b-col md="4" lg="4" class="mb-4">
				<b-card deck no-body variant="primary" header="Finansmodul" header-tag="h4">
					<b-list-group flush>
						<b-list-group-item class="d-flex w-100 justify-content-between">
							<strong>Opstart</strong>
							<span>kr. <animated-number :value="modules.finance.installation" :formatValue="short_price_format" /></span>
						</b-list-group-item>
						<b-list-group-item class="d-flex w-100 justify-content-between">
							<strong>Pris pr. måned</strong>
							<span>kr. <animated-number :value="modules.finance.subscription" :formatValue="short_price_format" /></span>
						</b-list-group-item>
					</b-list-group>
					<b-card-body>
						SkvizBiz finansmodul giver dig mulighed for at holde hele dit regnskab samlet ét sted - i SkvizBiz. SkvizBiz' finansmodul er registreret hos erhvervsstyrelsen som et godkendt standardbogføringssystem med registreringsnummer 'fob668761'. Med finansmodulet kan du indlæse udgifter fra banken, så du kun skal kontere dem i programmet. Programmet kan så lave saldobalance, momsrapport, kontospecifikation og andre udtræk til dig, samt indberette moms via Skattestyrelesens moms-API. Og du kan gemme din bogføring og dine bilag direkte i SkvizBiz, og der er inkluderet 1GB dataplads til bilag (se priser for yderligere lagring af bilag under "Ekstra dataplads" længere nede på siden).
					</b-card-body>
				</b-card>
			</b-col>
			<b-col md="4" lg="4" class="mb-4">
				<b-card deck no-body variant="primary" header="SMS-modul" header-tag="h4">
					<b-list-group flush>
						<b-list-group-item class="d-flex w-100 justify-content-between">
							<strong>Opstart</strong>
							kr. 0,- (inkluderet)
						</b-list-group-item>
						<b-list-group-item class="d-flex w-100 justify-content-between">
							<strong>Pris pr. SMS</strong>
							fra kr. 0,35
						</b-list-group-item>
					</b-list-group>
					<b-card-body>
						<p>SMS-modulet gør det let for dig at sende en SMS til dine kunder inden du kommer og pudser. Nogle kunder skal kun have besked ved indvendig pudsning, og det kan SMS-modulet også holde styr på for dig.</p>
						<p>Du kan også sende fakturaer direkte på SMS. Og hvis du samtidig tilbyder kunderne at betale med MobilePay så kan det næsten ikke blive lettere for dine kunder at modtage og betale deres regninger.</p>
						<p>Prisen er afhængig af hvor mange SMS-point du køber ad gangen, og om du sender til Danmark eller andre lande. Kontakt os for nærmere information.</p>
					</b-card-body>
				</b-card>
			</b-col>
			<b-col md="4" lg="4" class="mb-4">
				<b-card deck no-body variant="primary" header="E-faktura-modul" header-tag="h4">
					<b-list-group flush>
						<b-list-group-item class="d-flex w-100 justify-content-between">
							<strong>Opstart</strong>
							kr. 0,- (inkluderet)
						</b-list-group-item>
						<b-list-group-item class="d-flex w-100 justify-content-between">
							<strong>Pris for afsendelse</strong>
							fra kr. 3,75/e-faktura
						</b-list-group-item>
						<b-list-group-item class="d-flex w-100 justify-content-between">
							<strong>Pris for modtagelse</strong>
							kr. 1,20/e-faktura
						</b-list-group-item>
					</b-list-group>
					<b-card-body>
						<p>E-faktura-modulet giver dig mulighed for let at sende og modtage regninger til offentlige institutioner og andre virksomheder som benytter E-fakturaer.</p>
						<p>SkvizBiz kan automatisk sende E-fakturaerne for dig, og tjekker selv op på om modtageren godkender fakturaen. Og du får naturligvis besked direkte i SkvizBiz, hvis en E-faktura ikke blev godkendt.</p>
						<p>Prisen for afsendelse er afhængig af hvor mange EAN-frimærker du køber ad gangen. Kontakt os for nærmere information.</p>
						<p>Du kan også tilmelde dig NemHandel-registeret og modtage e-fakturaer på dit CVR-nummer, eller på et EAN-nummer hvis du vælger at købe sådan et.</p>
					</b-card-body>
				</b-card>
			</b-col>
		</div>

		<hr>

		<h2 class="mt-4 mb-2">MobilePay</h2>
		<p>SkvizBiz integrerer med Vipps MobilePay. Du kan se priserne på de forskellige integrationer herunder, og hvis du gerne vil vide mere om forskellene på de to integrationer, så læs <a href="/blog/2025/vipps_mobilepay">dette blogindlæg</a>.</p>
		<div class="row">
			<b-col md="6" lg="6" class="mb-4">
				<b-card deck no-body variant="primary" header="Vipps MobilePay ePayments" header-tag="h4">
					<b-list-group flush>
						<b-list-group-item>
							<strong>Opstart</strong>
							<span class="float-right">kr. 0,-</span>
						</b-list-group-item>
						<b-list-group-item>
							<strong>Fast pris pr. måned</strong>
							<span class="float-right">kr. 0,-</span>
						</b-list-group-item>
						<b-list-group-item class="d-flex w-100 justify-content-between">
							<strong>Pris pr. betaling til Vipps MobilePay</strong>
							0,69% af beløbet + kr. 1,-
						</b-list-group-item>
						<b-list-group-item class="d-flex w-100 justify-content-between">
							<strong>Pris pr. betaling til SkvizBiz</strong>
							0,4% af beløbet
						</b-list-group-item>
					</b-list-group>
					<b-card-body>
						<p>SkvizBiz samarbejder fuldt ud med Vipps MobilePay ePayments. Du kan tilmelde dig ePayments via et link på din SkvizBiz-konto, og få glæde af en billigere pris vi har forhandlet os frem til.<br>Når ePayments er sat op, så får alle dine kunder en QR-kode på deres fakturaer, samt evt. et betalingslink i deres fakturaemails, hvis du tilvælger det. Når de betaler via QR-koden eller betalingslinket, så registreres og bogføres indbetalingen helt automatisk på kunden inden for få sekunder, og uden at du skal røre en finger. Det er både smart og tidsbesparende!</p>
						<p>Betalingerne håndteres af Vipps MobilePay, filial af Vipps MobilePay AS, Norge. Hver betaling koster 0,69% af beløbet + 1 kr. som indeholdes af Vipps MobilePay, og derudover 0,4% af beløbet til SkvizBiz som faktureres løbende.<br>Så den samlede pris for dig vil være 1,09% + 1 kr. pr. betaling.</p>
					</b-card-body>
				</b-card>
			</b-col>
			<b-col md="6" lg="6" class="mb-4">
				<b-card deck no-body variant="primary" header="MobilePay Valgfrit Beløb (tidl. MyShop)" header-tag="h4">
					<b-list-group flush>
						<b-list-group-item>
							<strong>Opstart</strong>
							<span class="float-right">kr. 0,-</span>
						</b-list-group-item>
						<b-list-group-item>
							<strong>Fast pris pr. måned</strong>
							<span class="float-right">kr. 0,-</span>
						</b-list-group-item>
						<b-list-group-item class="d-flex w-100 justify-content-between">
							<strong>Typisk pris pr. betaling til Vipps MobilePay</strong>
							0,99% af beløbet
						</b-list-group-item>
						<b-list-group-item class="d-flex w-100 justify-content-between">
							<strong>Pris pr. betaling til SkvizBiz</strong>
							kr. 1,49
						</b-list-group-item>
					</b-list-group>
					<b-card-body>
						<p>MobilePay Valgfrit Beløb (tidligere kaldet MyShop) fungerer fortsat sammen med SkvizBiz. Hvis du har en Valgfrit Beløb-løsning hos MobilePay i dag, så kan SkvizBiz danne QR-koder på kundernes fakturaer, samt et betalingslink i deres email. Når de benytter enten QR-koden eller betalingslinket, så indlæses og bogføres indbetalingen automatisk på kunden.</p>
						<p>Betalingerne håndteres af Vipps MobilePay, filial af Vipps MobilePay AS, Norge. Prisen varierer fra virksomhed til virksomhed, men hver betalings koster typisk 0,99% af beløbet pr. betaling. Derudover fakturerer SkvizBiz løbende kr. 1,49 pr. betaling.<br>Så den samlede pris for dig vil være 0,99% + kr. 1,49 pr. betaling.</p>
					</b-card-body>
				</b-card>
			</b-col>
		</div>

		<hr>

		<h2 class="mt-4 mb-2">Valgfri moduler</h2>
		<b-row>
			<b-col md="6" lg="6" class="mb-4">
				<b-card deck no-body variant="primary" header="Betalingsservice" header-tag="h4">
					<b-list-group flush>
						<b-list-group-item class="d-flex w-100 justify-content-between">
							<strong>Opstart</strong>
							<span>kr. <animated-number :value="modules.pbs.installation" :formatValue="short_price_format" /></span>
						</b-list-group-item>
						<b-list-group-item class="d-flex w-100 justify-content-between">
							<strong>Fast pris pr. måned</strong>
							<span>kr. <animated-number :value="0" :formatValue="short_price_format" /></span>
						</b-list-group-item>
						<b-list-group-item class="d-flex w-100 justify-content-between">
							<strong>Pris pr. betaling</strong>
							<span>kr. <animated-number :value="modules.pbs.max_price" :formatValue="short_price_format" /> - <animated-number :value="modules.pbs.min_price" :formatValue="short_price_format" /></span>
						</b-list-group-item>
					</b-list-group>
					<b-card-body>
						<p>Prisen starter ved {{ modules.pbs.max_price * 100 }} øre pr. opkrævning, og falder gradvis til {{ modules.pbs.min_price * 100 }} øre ved mere end {{ modules.pbs.min_price_threshold }} betalinger i måneden.</p>
						<p>Brug af Betalingsservice-modulet koster yderligere gebyr til Mastercard, som håndterer betalingerne. Kontakt Mastercard for at finde deres priser. Det er tilladt at lade kunden betale omkostningen, i modsætning til ved f.eks. MobilePay-betalinger.</p>
						<b-button size="sm"
							@click="pbs_show_more = !pbs_show_more"
							:class="pbs_show_more ? 'collapsed' : null"
							aria-controls="collapse4"
							:aria-expanded="pbs_show_more ? 'true' : 'false'">{{pbs_show_more ? 'Se mindre' : 'Se mere'}}</b-button>
					</b-card-body>
					<b-list-group flush>
						<b-collapse id="pbs_more" v-model="pbs_show_more">
							<b-list-group-item>Med Betalingsservice-modulet kan du tilbyde dine kunder at opkræve penge over Betalingsservice, og SkvizBiz holder så styr på hvilke beløb der skal opkræves fra hvilke kunder.<br>
							Det er en flot service du kan tilbyde dine kunder, og samtidig giver det dig nogle store fordele:
							<ul>
								<li>Du slipper for at rykke for betalinger fra kunder, der er tilmeldt Betalingsservice,</li>
								<li>og det viser sig at mange kunder er mere “loyale” mod den samme vinduespudser, når først de er tilmeldt Betalingsservice og ikke længere skal betale regninger løbende manuelt.</li>
							</ul>	
							</b-list-group-item>
						</b-collapse>
					</b-list-group>
				</b-card>
			</b-col>
			<b-col md="6" lg="6" class="mb-4">
				<b-card deck no-body variant="primary" header="Prisberegner" header-tag="h4">
					<b-list-group flush>
						<b-list-group-item class="d-flex w-100 justify-content-between">
							<strong>Opstart</strong>
							<span>kr. <animated-number :value="modules.offer.installation" :formatValue="short_price_format" /></span>
						</b-list-group-item>
						<b-list-group-item class="d-flex w-100 justify-content-between">
							<strong>Pris pr. måned</strong>
							<span>kr. <animated-number :value="modules.offer.subscription" :formatValue="short_price_format" /></span>
						</b-list-group-item>
					</b-list-group>
					<b-card-body>
						Prisberegneren er særligt til dig med medarbejdere. Det er et tillægsmodul, som giver dig og dine medarbejdere mulighed for at give ensartede tilbud, bare ved at tælle vinduerne op.
					</b-card-body>
				</b-card>
			</b-col>
		</b-row>

		<hr>

		<h2 class="mt-4 mb-2" id="andre_ydelser">Andre ydelser</h2>
		<b-card no-body deck>
			<table class="table table-striped mb-0">
				<tbody>
					<tr v-for="service in services" :key="service.title" @click="service.description_showing = !service.description_showing" style="cursor: pointer;">
						<td>
							<chevron :active="service.description_showing" style="top: .1em; margin-right: .5em;" />{{service.title}}<transition-grow><div v-show="service.description_showing" style="padding: .5em; box-sizing: border-box;" v-html="service.description"></div></transition-grow>
						</td>
						<td v-if="service.custom_price" align="right" style="white-space:nowrap">{{ service.custom_price }}</td>
						<td v-else align="right">kr. {{short_price_format(service.price)}}</td>
					</tr>
				</tbody>
			</table>
		</b-card>

		<hr>

		<b-row>
			<b-col>
				<small>
					Alle priser er i DKK og ekskl. moms.<br>
					<strong>1</strong> Indlæsning af data forudsætter at du kan levere en samlet datafil med kundeoplysninger i Excel- eller CSV-format. For en merpris kan vi også tilbyde at hjælpe dig med at udlæse data fra andre programmer, fx Microsoft C5, Midaware, E-conomic m.fl.<br>
					<strong>2</strong> Supporten må dog ikke misbruges, og benyttes supporttelefonen i så høj grad at vi ikke længere kan hjælpe vores andre kunder, forbeholder vi os ret til efter advarsel at fakturere den ekstraordinære support. Her gælder samme takst som "Ekstra online kursus".<br>
					<strong>3</strong> Abonnement faktureres for en faktureringsperiode forud. Programmet kan til enhver tid opsiges med 1 måneds varsel til udgangen af en abonnementsperiode. Prisen afhænger af hvor lang en periode man betaler for ad gangen.<br>
					<strong>4</strong> Brug af Betalingsservice-modulet koster yderligere gebyr til Mastercard, som håndterer betalingerne. Kontakt mastercard for at finde deres priser.
				</small>
			</b-col>
		</b-row>
	</b-container>
</template>

<script>
import AnimatedNumber from "~/components/AnimatedNumber";
import Chevron from "~/components/Chevron";
import TransitionGrow from "~/components/TransitionGrow";
import { farInfoCircle, farChevronRight } from "!!fa-icon-loader!~/assets/@fortawesome/fontawesome-pro/metadata/icons.json";

import {
	BContainer,
	BModal,
	BFormRadioGroup,
	BFormRadio,
	BBadge,
	BPopover,
	BCard,
	BListGroup,
	BListGroupItem,
	BCardBody,
	BFormCheckbox,
	BFormSelect,
	BButton,
	BButtonGroup,
	BRow,
	BCol,
	BCollapse,
	BFormSpinbutton,
	BFormInput,
} from "bootstrap-vue"

export default {
	components: {
		BContainer,
		BModal,
		BFormRadioGroup,
		BFormRadio,
		BBadge,
		BPopover,
		BCard,
		BListGroup,
		BListGroupItem,
		BCardBody,
		BFormCheckbox,
		BFormSelect,
		BButton,
		BButtonGroup,
		BRow,
		BCol,
		BCollapse,
		BFormSpinbutton,
		BFormInput,

		AnimatedNumber,
		Chevron,
		TransitionGrow,
		sbSignup: () => import('../components/Signup.vue'),
	},
	data: function() {
		return {
			show_signup: false,
			signup_loaded: false,
			pbs_show_more: false,
			version: 'standard',
			// price_period: "12",
			prices: {
				"1": {
					full_version: {
						start: "3.995,-",
						monthly: "99366,45",
					},
					lite_version: {
						start: "1.995,-",
						monthly: "99156,45",
					},
					pbs: {
						start: "995,-",
						monthly: "0,-",
					},
					offermodule: {
						start: "995,-",
						monthly: "49,-",
					},
				},
			},

			base_full: {
				optional: false,
				installation: 3495,
				subscription: {
					1: 399,
				},
			},
			base_lite: {
				optional: false,
				installation: 1495,
				subscription: {
					1: 100,
				},
				max_additional_customers: 149,
				additional_customer_price: 2,
				estimated_customers: 50,
			},
			users: {
				active: 0,
				increment: 1,
				threshold: 40,
				price: 75,
				module_active: true,
			},
			pbs: {
				estimated_monthly_payments: 40,
			},
			modules_active: ['finance'],
			period: 1,
			services: [
				{
					"title": "Dataudlæsning",
					"price": 995,
					"description_showing": false,
					"description": `I forbindelse med opstart tilbyder vi at hjælpe med at udlæse data fra dit nuværende system, hvis du ikke selv har mod på det.<br>
									Det er ikke alle systemer vi kan udlæse data fra, men kontakt os, så undersøger vi om det kan lade sig gøre.`,
				},
				{
					"title": "Ekstra fakturaskabelon",
					"price": 995,
					"description_showing": false,
					"description": `Med en ekstra fakturaskabelon kan 2 firmanavne (under samme CVR-nr) bruge samme SkvizBiz-konto. Den ekstra fakturaskabelon tilknyttes en eller flere kundegrupper, og kan sættes op med eget logo og firmanavn, egen adresse osv.`,
				},
				{
					"title": "Ekstra online kursus",
					"price": 995,
					"description_showing": false,
					"description": `Almindelig support er inkluderet i abonnement, men ønskes ekstra kursus eller kursus til ny medarbejder, kan vi tilbyde dette mod timebetaling.`,
				},
				{
					"title": "Programmørhjælp, pr. time",
					"price": 995,
					"description_showing": false,
					"description": `F.eks. speciel programmering, tilretning af programmet, særlige udtræk, osv.<br><br>
									Ønsker du en fast pris på et projekt, så er det også muligt på forhånd at aftale en pris.<br>Vi forbeholder os retten til at afvise ønsker til tilretninger og specialudvikling, og vi beholder rettighederne til alt specialprogrammering.`,
				},
				{
					"title": "Indlæsning af kundeoplysninger fra andre systemer",
					"price": 1495,
					"description_showing": false,
					"description": `Indlæsning af kundeoplysninger fra andre systemer.<br><br>Indlæsning fra et andet system er inkluderet i oprettelsen af en fuld version, men ønskes der efterfølgende yderligere indlæsning af kundedata fra andre systemer tilbyder vi dette mod betaling.<br><br>Kontakt os evt. med et eksempel på de udlæste data, så kan vi vejlede i hvad der kan indlæses til SkvizBiz.`,
				},
				{
					"title": "Genåbning",
					"price": 995,
					"description_showing": false,
					"description": `Hvis du lukker din SkvizBiz-konto eller sætter dit abonnement i bero, kan du senere få adgang til din SkvizBiz-konto igen ved at betale et genåbningsgebyr.<br>
									<strong>Bemærk dog, at hvis du beder os slette dine data, så slettes kundedata uigenkaldeligt i overensstemmelse med GDPR!</strong> Regnskabsdata opbevarer vi uanset hvad i 5 år, i overensstemmelse med gældende lovgivning.`,
				},
				{
					"title": "Kuratoradgang",
					"price": 1495,
					"description_showing": false,
					"description": `Hvis din virksomhed går konkurs og en kurator skal have fuld adgang til systemet, så dækker denne faste pris indlæsning af kontoen fra vores backup og genaktivering af adgangen, samt en måneds abonnement uanset moduler eller antal medarbejdere.<br><br>Hvis alt du har brug for er de bogførte posteringer og bilag, så kontakt mail@skvizbiz.dk, så udleverer vi dem uden omkostninger, i henhold til "Bekendtgørelse om krav til digitale standard bogføringssystemer" §11.`,
				},
				{
					"title": "Arkivadgang i 5 år",
					"price": 1995,
					"description_showing": false,
					"description": `Hvis du ikke længere ønsker aktivt at bruge SkvizBiz, men gerne vil have fri adgang til dine data mens vi opbevarer dem i de lovpligtige 5 år, så kan du betale for en arkivadgang. Det koster et engangsbeløb og giver læse-adgang til dit regnskab i 5 år. Hvis du ikke har brug for fri adgang, men alt du har brug for er en udlæsning af de bogførte posteringer og bilag, så kontakt mail@skvizbiz.dk. Så udleverer vi dem uden omkostninger, i henhold til "Bekendtgørelse om krav til digitale standard bogføringssystemer" §11.`,
				},
				{
					"title": "Ekstra dataplads, pr. 1GB",
					"custom_price": "kr. 10,-/md.",
					"description_showing": false,
					"description": `Der er inkluderet 1GB gratis dataplads til billeder og filer i dit abonnement. Men har du brug for mere plads til f.eks. regnskabsbilag, kontrakter eller kundebilleder, så kan du tilkøbe ekstra lagerplads.<br>
									Ved at gemme dine bilag og kundefiler i SkvizBiz slipper du for en masse bekymringer:
									<ul>
										<li>Vi sørger for at vedligeholde harddiske</li>
										<li>Vi laver løbende backup så dine data ikke går tabt</li>
										<li>Du får hurtig adgang til filer direkte fra SkvizBiz</li>
										<li>Du får let mulighed for evt. sletning af kundefiler sammen med kundedata så du overholder GDPR</li>
										<li>Vi gemmer alle filer på vores egne servere, så du ikke behøver bekymre dig om hvor dine data bliver gemt, og om du uforvarende bryder persondataforordningen. Du må dog fortsat ikke gemme følsomme personoplysninger, heller ikke i filer som uploades til SkvizBiz.</li>
									</ul>
									Kunder, fakturaer og ruteplaner regnes ikke med i din dataplads – det er kun ekstra billeder og filer der uploades, som tæller med.`,
				},
			],
		};
	},

	computed: {
		price_period: function(){return this.period},
		variable_prices: function() {
			let base_lite = this.base_lite;
			let ret = {
				lite: {
					subscription: base_lite.subscription[1],
				},
			};
			if (base_lite.estimated_customers <= 50) {
				ret.lite.subscription = base_lite.subscription[1];
			} else {
				ret.lite.subscription = base_lite.subscription[1] + Math.min(base_lite.estimated_customers-50, base_lite.max_additional_customers) * base_lite.additional_customer_price;
			}
			return ret;
		},
		modules: function() {
			let lite = this.version === 'lite';
			let modules_active = this.modules_active;
			let ret = {
				invoice_setup: {
					name: "Egen fakturaopsætning",
					active: !!~modules_active.indexOf('invoice_setup'),
					optional: lite ? true : false,
					installation: lite ? 995 : 0,
					subscription: 0,
				},
				data_import: {
					name: "Indlæsning af kundedata ved opstart",
					active: !!~modules_active.indexOf('data_import'),
					optional: lite ? true : false,
					installation: lite ? 1495 : 0,
					subscription: 0,
				},
				finance: {
					name: "Finansmodul",
					active: !!~modules_active.indexOf('finance'),
					optional: false,
					installation: 0,
					subscription: 75,
					info: `SkvizBiz' finansmodul er registreret hos erhvervsstyrelsen som et godkendt standardbogføringssystem med registreringsnummer 'fob668761'`,
				},
				pbs: {
					name: "Betalingsservice-modul",
					active: !!~modules_active.indexOf('pbs'),
					optional: true,
					installation: 995,
					subscription: 0,
					max_price: 0.6,
					min_price: 0.25,
					min_price_threshold: 800,
				},
				offer: {
					name: "Prisberegner",
					active: !!~modules_active.indexOf('offer'),
					optional: true,
					installation: 995,
					subscription: 49,
				},
				api: {
					name: "API-modul",
					active: !!~modules_active.indexOf('api'),
					optional: true,
					installation: 995,
					subscription: 49,
					info: `<h4>Hvad er API-modulet?</h4>
							<p>Med API-modulet kan andre systemer integrere med SkvizBiz.</p>
							<p>Det vil sige, at hvis du f.eks. har en formular på din hjemmeside, hvor dine kunder kan anmode om et tilbud på vinduespudsning, så vil du med API-modulet kunne oprette kunderne og tilbuddet direkte i SkvizBiz.</p>
							<p class="mb-0">Det vil i så fald kræve at udviklerne af din hjemmeside vil integrere med SkvizBiz, og den tekniske beskrivelse af hvordan man gør kan de finde her: <a href="https://secure.skvizbiz.dk/api/docs/" target="_blank">https://secure.skvizbiz.dk/api/docs/</a></p>
					`,
				},
			};

			/* if (!ret.pbs.active) {
				ret.pbs.subscription = 0;	
			} else  */if (this.pbs.estimated_monthly_payments >= 800) {
				ret.pbs.subscription = ret.pbs.min_price * this.pbs.estimated_monthly_payments;
			} else {
				let a = (ret.pbs.min_price - ret.pbs.max_price) / ret.pbs.min_price_threshold;
				let b = ret.pbs.max_price;
				ret.pbs.subscription = this.pbs.estimated_monthly_payments * (a * this.pbs.estimated_monthly_payments + b);
			}
			ret.pbs.info = `<p>Prisen starter ved ${ ret.pbs.max_price * 100 } øre pr. opkrævning, og falder gradvis til ${ ret.pbs.min_price * 100 } øre ved mere end ${ ret.pbs.min_price_threshold } betalinger i måneden.</p>
						<p class="mb-0">Brug af Betalingsservice-modulet koster yderligere gebyr til Mastercard, som håndterer betalingerne. Kontakt Mastercard for at finde deres priser. Det er tilladt at lade kunden betale omkostningen, i modsætning til ved f.eks. MobilePay-betalinger.</p>`

			return ret;
		},
		months_left_in_year: function() {
			var d = new Date();
			return 12 - (d.getMonth() + 1) + (d.getDate() < 20 ? 1 : 0);
		},
		months_left_in_quarter: function() {
			return ((this.months_left_in_year - 1) % 3) + 1;
		},
		months_left_in_period: function() {
			switch (this.period) {
				case 12:
					return this.months_left_in_year;
				case 3:
					return this.months_left_in_quarter;
				default:
					return 1;
			}
		},
		period_string: function() {
			return this.get_period_string(this.period);
		},
		mail_string: function() {
			return this.get_mail_string(this.period);
		},
		base: function() {
			let base_full = this.base_full;
			let base_lite = this.base_lite;
			if (this.version === 'standard') {
				return base_full;
			} else {
				return base_lite;
			}
		},
		farInfoCircle() {return farInfoCircle},
		farChevronRight() {return farChevronRight},
	},

	methods: {
		price_format: SB_FormatNumber,
		short_price_format: SB_FormatPriceSimple,
		total_installation: function() {
			var self = this;
			var price = this.base.installation;
			if (this.users.module_active && this.version != 'lite') {
				price += this.employee_module(1).installation;
			}
			// this.modules_active.forEach((module)=>{
			// 	price += self.modules[module].installation;
			// })
			// return price;

			for (let x in this.modules) {
				if (~this.modules_active.indexOf(x) || !this.modules[x].optional) {
					price += this.modules[x].installation
				}
				// var item = this.modules[x];
				// if (item.active) {
				// 	base.price += item.subscription;
				// }
			}
			return price;
		},
		employee_module: function(period) {
			var users = this.users.active;
			// if (this.users.active > this.users.threshold) {
			// 	users =
			// 		Math.ceil(this.users.active / this.users.increment) *
			// 		this.users.increment;
			// } else {
			// 	users = this.users.threshold;
			// }
			// var price = this.base_full.subscription[users];
			var price = this.users.price * this.users.active
			// var discount = 0;
			// if ((discount = this.base_full.discounts[users][period])) {
			// 	price -= discount;
			// } else {
			// 	discount = 0;
			// }

			if (this.version === 'standard' || true) {
				return {
					installation: 0,
					subscription: price/* - (this.base_full.subscription[1]  - (this.base_full.discounts[1][period] ? this.base_full.discounts[1][period] : 0) )*/,
				};
			} else {
				return {
					installation: 995,
					subscription: price/* - (this.base_full.subscription[1]  - (this.base_full.discounts[1][period] ? this.base_full.discounts[1][period] : 0) )*/,
				};
			}
		},
		total_subscription: function(period) {
			var base = {
				price: this.base.subscription[1]/*  - (this.base.discounts[1][period] ? this.base.discounts[1][period] : 0) */,
			};
			if (this.version == 'lite') {
				base.price = this.variable_prices.lite.subscription;
			}
			if (this.users.module_active && this.version != 'lite') {
				base.price += this.employee_module(period).subscription;
			}
			// let self = this;
			// this.modules_active.forEach((module)=>{
			// 	base.price += self.modules[module].subscription;
			// })
			// return base;

			for (let x in this.modules) {
				if (~this.modules_active.indexOf(x) || !this.modules[x].optional) {
					base.price += this.modules[x].subscription
				}
				// var item = this.modules[x];
				// if (item.active) {
				// 	base.price += item.subscription;
				// }
			}
			return base;
		},
		get_period_string: function(period) {
			switch (period) {
				case 12:
				case "12":
					return "årsfakturering";
				case 3:
				case "3":
					return "kvartalsfakturering";
				default:
					return "månedsfakturering";
			}
		},
		get_mail_string: function(period) {
			var modules = this.modules;
			var active_modules = [];
			for (let x in modules) {
				var item = modules[x];
				if (item.active) {
					active_modules.push(item.name);
				}
			}
			var module_string = active_modules.join("\n");
			return (
				"mailto:mail@skvizbiz.dk?subject=Bestilling%20af%20SkvizBiz&body=" +
				encodeURI(
					"Kære SkvizBiz\n\nJeg vil gerne opgradere min demo-konto til en fuld version " +
						(this.users.active == 1
							? "uden medarbejdermodul"
							: "med op til " +
							  this.users.active +
							  " medarbejdere/logins") +
						".\nJeg ønsker " +
						this.get_period_string(period) +
						".\n\n" +
						(module_string
							? "Jeg ønsker følgende moduler:\n" + module_string
							: "Jeg ønsker ingen ekstra moduler") +
						"\n\nMed venlig hilsen\n<?=INVOICE_COMPANY_NAME?>"
				)
			);
		},
		toggle_module: function(id) {
			if (!this.modules[id].optional) {
				return ;
			}
			let index = this.modules_active.indexOf(id);
			if (!!~index) {
				this.modules_active.splice(index, 1);
			} else {
				this.modules_active.push(id);
			}
		},
	},
	watch: {
	// 	version: function(newValue) {
	// 		if (newValue === 'lite') {
	// 			if (!~ this.modules_active.indexOf('finance')) {
	// 				this.modules_active.push('finance');
	// 			}
	// 		}
	// 	},
		"version": function(newValue) {
			this.users.module_active = newValue == "standard";
		}
	},
};

function SB_FormatPriceSimple(num) {
	if (num == Math.round(num)) {
		return `${__number_format(num, 0, ",", ".")},-`;
	} else {
		return SB_FormatNumber(num);
	}
}

function SB_FormatNumber(num) {
	return __number_format(num, 2, ",", ".");
}
function __number_format(number, decimals, dec_point, thousands_sep) {
	// Formats a number with grouped thousands
	//
	// version: 1109.2015
	// discuss at: http://phpjs.org/functions/number_format    // +   original by: Jonas Raoni Soares Silva (http://www.jsfromhell.com)
	// +   improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
	// +     bugfix by: Michael White (http://getsprink.com)
	// +     bugfix by: Benjamin Lupton
	// +     bugfix by: Allan Jensen (http://www.winternet.no)    // +    revised by: Jonas Raoni Soares Silva (http://www.jsfromhell.com)
	// +     bugfix by: Howard Yeend
	// +    revised by: Luke Smith (http://lucassmith.name)
	// +     bugfix by: Diogo Resende
	// +     bugfix by: Rival    // +      input by: Kheang Hok Chin (http://www.distantia.ca/)
	// +   improved by: davook
	// +   improved by: Brett Zamir (http://brett-zamir.me)
	// +      input by: Jay Klehr
	// +   improved by: Brett Zamir (http://brett-zamir.me)    // +      input by: Amir Habibi (http://www.residence-mixte.com/)
	// +     bugfix by: Brett Zamir (http://brett-zamir.me)
	// +   improved by: Theriault
	// +      input by: Amirouche
	// +   improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)    // *     example 1: number_format(1234.56);
	// *     returns 1: '1,235'
	// *     example 2: number_format(1234.56, 2, ',', ' ');
	// *     returns 2: '1 234,56'
	// *     example 3: number_format(1234.5678, 2, '.', '');    // *     returns 3: '1234.57'
	// *     example 4: number_format(67, 2, ',', '.');
	// *     returns 4: '67,00'
	// *     example 5: number_format(1000);
	// *     returns 5: '1,000'    // *     example 6: number_format(67.311, 2);
	// *     returns 6: '67.31'
	// *     example 7: number_format(1000.55, 1);
	// *     returns 7: '1,000.6'
	// *     example 8: number_format(67000, 5, ',', '.');    // *     returns 8: '67.000,00000'
	// *     example 9: number_format(0.9, 0);
	// *     returns 9: '1'
	// *    example 10: number_format('1.20', 2);
	// *    returns 10: '1.20'    // *    example 11: number_format('1.20', 4);
	// *    returns 11: '1.2000'
	// *    example 12: number_format('1.2000', 3);
	// *    returns 12: '1.200'
	// *    example 13: number_format('1 000,50', 2, '.', ' ');    // *    returns 13: '100 050.00'
	// Strip all characters but numerical ones.
	number = (number + "").replace(/[^0-9+\-Ee.]/g, "");
	var n = !isFinite(+number) ? 0 : +number,
		prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
		sep = typeof thousands_sep === "undefined" ? "," : thousands_sep,
		dec = typeof dec_point === "undefined" ? "." : dec_point,
		s = "",
		toFixedFix = function(n, prec) {
			var k = Math.pow(10, prec);
			return "" + Math.round(n * k) / k;
		};
	// Fix for IE parseFloat(0.55).toFixed(0) = 0;
	s = (prec ? toFixedFix(n, prec) : "" + Math.round(n)).split(".");
	if (s[0].length > 3) {
		s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
	}
	if ((s[1] || "").length < prec) {
		s[1] = s[1] || "";
		s[1] += new Array(prec - s[1].length + 1).join("0");
	}
	return s.join(dec);
}
</script>